﻿export class request_payment_url {
    public url_success: string | null = null;
    public url_failure: string | null = null;
    public url_cancellation: string | null = null;
}